// extracted by mini-css-extract-plugin
export var item = "RuledList-module--item--szENS";
export var list = "RuledList-module--list--0Ypz+";
export var ruleBottom = "RuledList-module--ruleBottom--znrID";
export var ruleTop = "RuledList-module--ruleTop--STS98";